import { usePageLevelEvents } from "@/hooks/usePageLevelEvents/usePageLevelEvents";
import { Product, Variant, PageConfig, FeatureFlags } from "@/types/types";

type Props = {
  product: Product;
  selectedVariant: Variant;
  pageConfig: PageConfig;
  flags?: FeatureFlags;
};

export const PageLevelEvents = ({
  product,
  selectedVariant,
  pageConfig,
  flags,
}: Props) => {
  usePageLevelEvents({
    product,
    selectedVariant,
    pageConfig,
    flags,
  });

  return null;
};
